import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './marketOverview.scss';
import { WhiteEllipseImage, ZoomDevice } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const MarketOverview = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js';
    script.async = true;

    script.innerHTML = JSON.stringify({
      width: '100%',
      height: '100%',
      symbolsGroups: [
        {
          name: 'Indices',
          originalName: 'Indices',
          symbols: [
            {
              name: 'FOREXCOM:SPXUSD',
              displayName: 'S&P 500 Index',
            },
            {
              name: 'FOREXCOM:NSXUSD',
              displayName: 'US 100 Cash CFD',
            },
            {
              name: 'FOREXCOM:DJI',
              displayName: 'Dow Jones Industrial Average Index',
            },
            {
              name: 'INDEX:NKY',
              displayName: 'Japan 225',
            },
            {
              name: 'INDEX:DEU40',
              displayName: 'DAX Index',
            },
            {
              name: 'FOREXCOM:UKXGBP',
              displayName: 'FTSE 100 Index',
            },
          ],
        },
        {
          name: 'Futures',
          originalName: 'Futures',
          symbols: [
            {
              name: 'CME_MINI:ES1!',
              displayName: 'S&P 500',
            },
            {
              name: 'CME:6E1!',
              displayName: 'Euro',
            },
            {
              name: 'COMEX:GC1!',
              displayName: 'Gold',
            },
            {
              name: 'NYMEX:CL1!',
              displayName: 'WTI Crude Oil',
            },
            {
              name: 'NYMEX:NG1!',
              displayName: 'Gas',
            },
            {
              name: 'CBOT:ZC1!',
              displayName: 'Corn',
            },
          ],
        },
        {
          name: 'Bonds',
          originalName: 'Bonds',
          symbols: [
            {
              name: 'CBOT:ZB1!',
              displayName: 'T-Bond',
            },
            {
              name: 'CBOT:UB1!',
              displayName: 'Ultra T-Bond',
            },
            {
              name: 'EUREX:FGBL1!',
              displayName: 'Euro Bund',
            },
            {
              name: 'EUREX:FBTP1!',
              displayName: 'Euro BTP',
            },
            {
              name: 'EUREX:FGBM1!',
              displayName: 'Euro BOBL',
            },
          ],
        },
        {
          name: 'Forex',
          originalName: 'Forex',
          symbols: [
            {
              name: 'FX:EURUSD',
              displayName: 'EUR to USD',
            },
            {
              name: 'FX:GBPUSD',
              displayName: 'GBP to USD',
            },
            {
              name: 'FX:USDJPY',
              displayName: 'USD to JPY',
            },
            {
              name: 'FX:USDCHF',
              displayName: 'USD to CHF',
            },
            {
              name: 'FX:AUDUSD',
              displayName: 'AUD to USD',
            },
            {
              name: 'FX:USDCAD',
              displayName: 'USD to CAD',
            },
          ],
        },
      ],
      showSymbolLogo: true,
      colorTheme: 'light',
      isTransparent: false,
      locale: 'en',
    });

    // 3) Append the script into the container
    const container = document.getElementById('tradingview-widget-container');
    if (container) {
      container.appendChild(script);
    }
  }, []);

  return (
    <>
      <div className="market-overview-transparent-content" />
      <div className="market-overview">
        <div className={`market-overview-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
          <div className="market-overview-card">
            <h1 className="market-overview-title">
              <blue-text>{t('marketOverview:overview')}</blue-text>{' '}
              <blue-underline>{t('marketOverview:market')}</blue-underline>
            </h1>
            <div className="market-overview-graph">
              <div id="tradingview-widget-container" />
            </div>
          </div>

          <img src={ZoomDevice} alt={ZoomDevice} className="market-overview-image-1" />
          <img
            src={WhiteEllipseImage}
            alt={WhiteEllipseImage}
            className="market-overview-image-2"
          />
          <img
            src={WhiteEllipseImage}
            alt={WhiteEllipseImage}
            className="market-overview-image-3"
          />
          <img
            src={WhiteEllipseImage}
            alt={WhiteEllipseImage}
            className="market-overview-image-4"
          />
        </div>
      </div>
    </>
  );
};
